module.exports = __webpack_public_path__ + "static/img/mchDown.d8c5ca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mchDown.png
// module id = WeRh
// module chunks = 2